import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';

export const GeneralSettings = () => {

  const isMounted = useRef(false);
  const [loanPeriod, setLoanPeriod] = useState({ days: '' });
  const [modalFor, setModalFor] = useState('');
  const [selectedOpt, setSelectedOpt] = useState('');
  const [switchData, setSwitchData] = useState();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [dataLoad, setDataLoad] = useState(false);

  const fetchRule = async () => {
    try {
      const res = await withRFSToken.post('uld-settings/get-demurrage-days', {});
      // .then(function (res) {
      if (res.data.response_code === 200) {
        setLoanPeriod({ days: res.data.response_data })
      } else {
        toast.error(res.data.response_msg);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const fetchUcmTime = async () => {
    try {
      const res = await withRFSToken.get('uld-settings/get-ucm-time', {});
      // .then(function (res) {
      const innerData = res.data.response_data
      if (res.data.response_code === 200) {
        const reData = innerData?.activity_status == 1 ? true : false;
        const timeData = innerData?.time_duration;
        setSwitchData(reData);
        setSelectedOpt(innerData?.activity_status == 1 ? timeData : null);
        setDataLoad(true)
      } else {
        toast.error(res.data.response_msg);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const timeOpt = [
    { label: '01', value: 1 },
    { label: '02', value: 2 },
    { label: '03', value: 3 },
    { label: '04', value: 4 },
    { label: '05', value: 5 },
    { label: '06', value: 6 },
    { label: '07', value: 7 },
    { label: '08', value: 8 },
    { label: '09', value: 9 },
    { label: '10', value: 10 },
    { label: '11', value: 11 },
    { label: '12', value: 12 },
  ];

  useEffect(() => {
    if (isMounted.current) return;
    fetchRule()
    fetchUcmTime()
    isMounted.current = true;
  }, []);
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    // const numericValue = value.replace(/\D/g, "");
    setLoanPeriod(prevData => ({
      ...prevData,
      [name]: value
    }));
  }
  const saveRule = async () => {
    try {
      const res = await withRFSToken.post('uld-settings/general-setting', { demurrage_days: loanPeriod.days });
      // .then(function (res) {
      if (res.data.response_code === 200) {
        toast.success('Demurrage Days Successfully');
      } else {
        toast.error(res.data.response_msg);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const switchChange = (e) => {
    const isChecked = e.target.checked;
    // setSwitchData(isChecked);
    const modalData = isChecked ? 'Y' : 'N';
    setModalFor(modalData)
    setShowConfirmation(true);
  }

  const handleEdit = () => {
    setModalFor('E')
    setShowConfirmation(true);
  }

  const handleConfirm = async (e) => {
    if (!selectedOpt) { toast.error('Please select time duration'); return; }
    if (e) {
      const data = modalFor == 'N' ? 0 : 1;
      // setSwitchData(data)
      try {
        const res = await withRFSToken.post('uld-settings/set-ucm-time', { activity_status: data, time_duration: selectedOpt });
        // .then(function (res) {
        const innerData = res.data.response_data
        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg);
          fetchUcmTime()
          setShowConfirmation(false);
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      setShowConfirmation(false);
    }
  }

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* <div className="">{console.log('loanPeriod', loanPeriod)}
        <Header logo_url={SBack ? SBack : '/ULDControl'} sBackUrl={SBack ? SBack : '/ULDControl'} />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel">
            <div className="row"> */}

              {/* <LeftSettings /> */}
              <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                  <h4>General Settings</h4>
                  <p>Set your notification preferences for when you are in or away from the dashboard.</p>
                  <hr />
                  <div className='d-flex align-items-center'>
                    <div className='me-3'>
                      <h4>Maximum Loan Period</h4>
                      <p className='mb-0'>ULD can be maximum on loan for</p>
                    </div>
                    <div className='d-flex align-items-center st_days'>
                      <Form.Control
                        type="text"
                        // value={loanPeriod.days ? `${loanPeriod.days} Days` : ""}
                        value={loanPeriod.days}
                        name='days'
                        onChange={handleInputChange}
                      />
                      <span className='me-3'>Day(s)</span>
                      <Button onClick={saveRule} className='save'>Save</Button>
                    </div>

                  </div>
                  <hr />
                  <div className='d-flex align-items-center'>
                    <div className='me-3'>
                      <h4>Automatic UCM In Processing</h4>
                      <p className='mb-0'>Enable this to allow the system to automatically process UCM In movements</p>
                    </div>
                    {dataLoad &&
                      <>
                        <div className='d-flex align-items-center st_days'>
                          {/* <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label="Activate Button"
                            onChange={switchChange}
                            checked={switchData}
                          /> */}
                          <div className="new_tgl me-3">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={switchData}
                                onChange={switchChange}
                                id={`custom-switch`}
                              />
                              <span className="slider-text">
                                <span className="off">
                                  No <span className="circle"></span>
                                </span>
                                <span className="on">
                                  Yes <span className="checkmark">✓</span>
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                        <span className='activa_ucm'>{selectedOpt} {selectedOpt == 1 ? 'Hour' : 'Hours'}  <span><FontAwesomeIcon onClick={handleEdit} icon={faPencil} /></span></span>
                      </>}
                  </div>
                </div>
              </div>
            {/* </div> */}
            <Modal className='addfrom change_type' show={showConfirmation} onHide={() => setShowConfirmation(false)} centered>
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body>
                {modalFor == 'N' &&
                  <>
                    <h3>Deactivate Automatic UCM In Processing</h3>
                    <p>Are you sure you want to Deactivate?</p>
                  </>
                }
                {modalFor == 'E' &&
                  <>
                    <h3>Edit Activate Automatic UCM In Processing</h3>
                    <p>Change the number of hours after which the UCM In will be automatically processed if no flight arrival time is available.</p>
                    <Form.Label>Set Hours field</Form.Label>
                    <Select
                      options={timeOpt}
                      onChange={(selected) => {
                        setSelectedOpt(selected.value);
                      }}
                      placeholder="Select"
                      className='down_selct'
                      name="message_type"
                      value={timeOpt.find(option => option.value === selectedOpt)}
                    />
                  </>
                }
                {modalFor == 'Y' &&
                  <>
                    <h3>Activate Automatic UCM In Processing</h3>
                    <p>Specify the number of hours after which the UCM In will be automatically processed if no flight arrival time is available.</p>
                    <Form.Label>Set Hours field</Form.Label>
                    <Select
                      options={timeOpt}
                      onChange={(selected) => {
                        setSelectedOpt(selected.value);
                      }}
                      placeholder="Select"
                      className='down_selct'
                      name="message_type"
                      value={timeOpt.find(option => option.value === selectedOpt)}
                    />
                  </>
                }
              </Modal.Body>
              <Modal.Footer>
                {modalFor !== 'E' &&
                  <div className='d-flex w-50 mx-auto are_bottom'>
                    <Button variant="secondary" onClick={() => handleConfirm(false)}>
                      No
                    </Button>
                    <Button variant="primary" onClick={() => handleConfirm(true)}>
                      Yes
                    </Button>
                  </div>
                }
                {modalFor == 'E' && <Button variant="primary" onClick={() => handleConfirm(true)}>Update</Button>}
              </Modal.Footer>
            </Modal>
          {/* </div>
        </div>
      </div> */}
    </>
  )
}

export default GeneralSettings;